// GENERATED by scripts/gen-slipstream.mjs — do not hand-edit; re-run the script.
// aspect = width / height of each public/slip/{key}.svg (all share one vertical frame).
export const SLIP = {
  "name": {
    "text": "AJ GERSTENHABER",
    "aspect": 10.7297
  },
  "about": {
    "text": "HI, I'M AJ.",
    "aspect": 5.7773
  },
  "work": {
    "text": "WORK HISTORY",
    "aspect": 9.0389
  },
  "lab": {
    "text": "THE FILM LAB",
    "aspect": 7.5968
  },
  "projects": {
    "text": "OTHER PROJECTS",
    "aspect": 9.8162
  },
  "letterboxd": {
    "text": "LETTERBOXD",
    "aspect": 7.3859
  },
  "cars": {
    "text": "CARS I'VE OWNED",
    "aspect": 10.2562
  },
  "experience": {
    "text": "PROFESSIONAL EXPERIENCE",
    "aspect": 15.9654
  },
  "education": {
    "text": "EDUCATION",
    "aspect": 6.8703
  }
} as const;

export type SlipKey = keyof typeof SLIP;
